export enum EditMode {
    None = 'None',
    SyncedFields = 'SyncedFields',
    All = 'All',
}
